import type { GetTemplatesParams } from '../types';

// ─── Query Key Factory ────────────────────────────────────────────────────────

export const templateKeys = {
  all: ['templates'] as const,
  detail: (id: string) => [...templateKeys.all, 'detail', id] as const,
  list: (params: GetTemplatesParams) => [...templateKeys.all, 'list', params] as const,
};
